<template>
  <v-switch
    v-model="enabled"
    :label="label"
    :color="sensorState.color"
    hide-details
  />
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { SensorCode } from "@/types/sensor/SensorCode";
import { SensorState } from "@/types/sensor/SensorState";

const props = defineProps<{
  chartid: string;
  label: string;
  sensorCode: SensorCode;
  sensorState: SensorState;
}>();

const emit = defineEmits(["updateEnabled"]);

const enabled = ref(props.sensorState.enabled);

watch(enabled, (newVal: boolean) => {
  emit("updateEnabled", props.sensorCode, newVal);
});
</script>

<style scoped lang="scss">
.v-switch {
  padding-left: 10px;
}
</style>
